import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { useModuleFromRoute } from '@/common/hooks/route/useModuleFromRoute';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { useCallback, useEffect, useMemo, useState } from 'react';

export const AbvOverUnderScenActionsList = ({ entityId }) => {
  const module = useModuleFromRoute();
  const rsrc = useRsrc();

  const [rows, setRows] = useState([]);

  useEffect(() => {
    const reqParam = {
      entity: 'ACTION',
      entityId,
    };

    rsrc.data(module, 'OVER_UNDER_SCEN_ACTIONS_DATA_PLUGIN', reqParam, 'ACTION').then((res) => {
      setRows(res ?? []);
    });
  }, [entityId, module, rsrc]);

  const fieldDefsFromRows = useMemo(() => {
    const firstRow = rows?.[0];
    if (!firstRow) {
      return {};
    }

    return Object.fromEntries(
      Object.keys(firstRow).map((field, index) => [
        field,
        {
          field,
          precedence: index,
        },
      ]),
    );
  }, [rows]);

  const augFieldDefs = useCallback(
    (fieldToFieldDef) => {
      Object.keys(fieldToFieldDef).forEach((field) => {
        // Update fieldDef from rows if exists, otherwise remove fieldDef to only show fields present in rows
        if (fieldDefsFromRows[field] == null) {
          delete fieldToFieldDef[field];
          return;
        }

        fieldToFieldDef[field] = { ...fieldToFieldDef[field], ...fieldDefsFromRows[field] };
      });

      Object.entries(fieldDefsFromRows).forEach(([field, dynamicFieldDef]) => {
        // Add any missing fields that are present in rows but not in fieldToFieldDef
        if (fieldToFieldDef[field] == null) {
          fieldToFieldDef[field] = dynamicFieldDef;
        }
      });
    },

    [fieldDefsFromRows],
  );

  const fieldDefsKey = useMemo(() => Object.keys(fieldDefsFromRows).join('|') || 'empty', [fieldDefsFromRows]);

  const clientSideRowData = useCallback(
    (setDataSource) => {
      setDataSource(rows ?? []);
    },
    [rows],
  );

  const augTabButtons = (tabButtons) => {
    tabButtons.splice(0, tabButtons.length);
  };

  return (
    <EntityList
      key={fieldDefsKey}
      augTabButtons={augTabButtons}
      showTitle={false}
      entity="ACTION"
      clientSideRowData={clientSideRowData}
      augFieldDefs={augFieldDefs}
    />
  );
};
